class ProductForm extends HTMLElement {
  connectedCallback() {
    this.form = this.querySelector('form');
    this.quantityInput = this.form.querySelector('input[name="quantity"]');
    this.variantIdInput = this.form.querySelector('input[name="id"]');

    this.submitButtons = this.form.querySelectorAll(
      `button[type="submit"], button[form="${this.form.getAttribute('id')}"]`
    );

    this.form.addEventListener('submit', (event) => this.onFormSubmit(event));

    this.unsubscribeVariantChange = subscribe(
      `variant:changed:${this.dataset.productId}`,
      ({ html }) => {
        const productForm = html.querySelector('product-form');
        this.replaceWith(productForm);
      }
    );

    this.unsubscribeQuantityChange = subscribe('quantity:change', ({ quantity }) => {
      this.quantityInput.value = quantity;
    });
  }

  disconnectedCallback() {
    this.unsubscribeVariantChange();
    this.unsubscribeQuantityChange();
  }

  /**
   * Handle form submission
   * @param {Event} event
   */
  async onFormSubmit(event) {
    event.preventDefault();
    this.toggleLoading(true);

    try {
      const formData = this.createFormData();
      const itemData = await this.addToCart(formData);
      this.onSuccess(itemData, formData.items[0].quantity);
    } catch (error) {
      this.onError(error);
    } finally {
      this.toggleLoading(false);
    }
  }

  /**
   * Toggle loading state on submit buttons
   * @param {boolean} loading
   */
  toggleLoading(loading) {
    this.submitButtons.forEach((button) => button.classList.toggle('button--loading', loading));
  }

  /**
   * Create form data
   * @returns {Object}
   */
  createFormData() {
    // Get all property inputs
    const propertyInputs = this.querySelectorAll('[name^="properties"]');
    const properties = {};

    // Build properties object from inputs
    propertyInputs.forEach((input) => {
      const propertyName = input.name.match(/properties\[(.*?)\]/)[1];
      properties[propertyName] = input.value;
    });

    return {
      items: [
        {
          id: this.variantIdInput.value,
          quantity: this.quantityInput.value,
          properties,
        },
      ],
    };
  }

  /**
   * Add to cart
   * @param {Object} formData
   * @returns {Object}
   */
  async addToCart(formData) {
    const response = await fetch(`${routes.cart_add_url}.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        ...formData,
        sections: ['fetch-cart-popover'],
      }),
    });

    const data = await response.json();
    if (!response.ok) throw new Error(data.message || 'Failed to add to cart');
    return data;
  }

  /**
   * Handle form success
   */
  onSuccess(itemData, quantity) {
    publish('cart:added', {
      items: itemData.items,
      quantity,
      sections: itemData.sections,
    });
  }

  /**
   * Handle form error
   * @param {Error} error - The error object
   */
  onError({ message }) {
    console.error(message);
  }
}

customElements.define('product-form', ProductForm);
